var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
export var login = function (apiUrl, values) {
    return fetch((apiUrl !== null && apiUrl !== void 0 ? apiUrl : '') + "/auth/token", {
        body: JSON.stringify(__assign(__assign({}, values), { grantType: 'password' })),
        method: 'POST',
    })
        .then(function (response) {
        return response.json();
    })
        .then(function (_a) {
        var _b = _a.data, accessToken = _b.accessToken, refreshToken = _b.refreshToken, errors = _a.errors;
        return {
            accessToken: accessToken,
            errors: errors,
            refreshToken: refreshToken,
        };
    });
};
